export default __webpack_public_path__ + "static/media/sign_in_illustration_2.037d17a6.svg";